/**
 * Supported languages in the wrapper
 * Both game and app use the same language codes
 */
export enum Languages {
  en = 'en',
  ru = 'ru',
}

/**
 * Locale configuration for the application
 * @property game - Language code passed to the game iframe
 * @property app - Language used for wrapper UI (limited to supported Languages enum)
 */
export interface Locale {
  game: string;
  app: Languages;
}
